import NavBar from '../components/navBar'
import Footer from '../components/footer'
import React, { useEffect } from 'react'
import api from '../services/api'
import { useDispatch, useSelector } from 'react-redux';

export default function TemplateHome({ element: component, footer = true }) {
    const definicoesSistema = useSelector((state) => state.definicoesSistema);
    const dispatch = useDispatch();

    useEffect(() => {
        api.get(`/definicoes/sistema/all`)
            .then(response => {
                dispatch({
                    type: 'definicoesSistema',
                    payload: {
                        definicoesSistema: response.data.definicoesSistema[0],
                    },
                });
            }).catch(err => '')
    }, [dispatch])


    return (
        <div style={{ marginTop: 100 }}>
            <NavBar />
            {/* {component} */}
            {React.cloneElement(component, { definicoesSistema: definicoesSistema })}

            {footer && <Footer />}
        </div>
    )
}
